/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventDayInfo,
    JsonEventDayInfoFromJSON,
    JsonEventDayInfoFromJSONTyped,
    JsonEventDayInfoToJSON,
} from './JsonEventDayInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventDayInfo
 */
export interface ApiResultOfListOfJsonEventDayInfo {
    /**
     * 
     * @type {Array<JsonEventDayInfo>}
     * @memberof ApiResultOfListOfJsonEventDayInfo
     */
    data?: Array<JsonEventDayInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventDayInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventDayInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventDayInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventDayInfo
     */
    result?: ApiResultOfListOfJsonEventDayInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventDayInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventDayInfoFromJSON(json: any): ApiResultOfListOfJsonEventDayInfo {
    return ApiResultOfListOfJsonEventDayInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventDayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventDayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventDayInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventDayInfoToJSON(value?: ApiResultOfListOfJsonEventDayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventDayInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

